(ns common.db.effects.dispatch-interval
  (:require [re-frame.core :as rf]))

(defonce interval-fx-db (atom {}))

(defn- dispatch-interval!
  "Effect for dispatching an event with an interval.
   The keyword `register` or `unregister` should be present.
   `ms` is required and should be a positive integer
   `event` is required and should be a vector of event to dispatch."
  [{:keys [register unregister ms event]}]
  {:pre [(and (keyword? (or register unregister))
              (if (keyword? register)
                (and (vector? event) (pos? ms))
                true))]}

  (letfn [(unregister-interval! [id]
            (when-let [interval-id (id @interval-fx-db)]
              (js/clearInterval interval-id)
              (swap! interval-fx-db dissoc id)))
          (dispatch-event [] (rf/dispatch event))]

    (when (and register (register @interval-fx-db))
      (rf/console :warn (str "dispatch-interval: overwriting " register)))

    (unregister-interval! (or register unregister))

    (when register
      (dispatch-event)
      (let [new-id (js/setInterval dispatch-event ms)]
        (swap! interval-fx-db assoc register new-id)))))

(rf/reg-fx :dispatch-interval
  dispatch-interval!)

(rf/reg-fx :dispatch-interval-n
  (fn [coll]
    (doall (for [reg coll]
             (dispatch-interval! reg)))))
